import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const AuditDescription = ({ data }) => {
  const { t } = useTranslation();
  const eventType = data.message.eventType;
  const email = data.message.mail.destination.toString();

  let typeDescription = t(`notification:audit:${eventType}`);
  let title = t('notification:audit:description', { email, typeDescription });
  return (
    <Typography component='span' color='textSecondary' title={title}>
      {title}
    </Typography>);
};

AuditDescription.propTypes = {
  notif: PropTypes.object,
  data: PropTypes.object
};

export default AuditDescription;
